export const LEFT_SIDE_WIDTH_RANGE = { min: 15, max: 35 };
export const RIGHT_SIDE_WIDTH_RANGE = { min: 15, max: 35 };
